<script lang="ts">
  import { Plus } from '@lucide/svelte';
  import { PARAMETERS, PLOTS, parameterById, plotByKind } from '../lib/registry';
  import { createPlotSpec } from '../lib/workspace-state';
  import type { PlotKind, PlotSpec } from '../lib/types';

  export let onAdd: (plot: PlotSpec) => void;
  export let disabled = false;

  let parameterId = PARAMETERS[0].id;
  let kind: PlotKind = 'average-series';
  $: parameter = parameterById(parameterId);
  $: definition = plotByKind(kind);
  $: reason = disabled
    ? 'Remove a plot before adding another.'
    : definition.incompatibilityReason(parameter);

  function add() {
    if (disabled || reason) return;
    onAdd(createPlotSpec(kind, parameterId));
  }
</script>

<section class="add-plot" aria-labelledby="add-plot-heading">
  <h2 id="add-plot-heading">Add plot</h2>
  <div class="add-plot__row">
    <label>Parameter
      <select bind:value={parameterId}>
        {#each PARAMETERS as item}<option value={item.id}>{item.name}</option>{/each}
      </select>
    </label>
    <label>Plot type
      <select bind:value={kind}>
        {#each PLOTS as item}
          <option value={item.kind} disabled={!item.compatible(parameter)}>{item.name}</option>
        {/each}
      </select>
    </label>
    <button class="button button--primary" type="button" disabled={Boolean(reason)} on:click={add}>
      <Plus size={18} aria-hidden="true" /> Add plot
    </button>
  </div>
  {#if reason}<p class="field-help" role="status">{reason}</p>{/if}
</section>
